// UI strings for listening cards (card type 'listen', listencards/; engine pedagogy/listen-cards.ts):
// the card face (hear a word, recall its meaning, the text only on request), the voice's label, the
// word page's "Kelpaa kuuntelukorttiin" row and the week's Kuuntele step. Finnish (default) and
// English side by side; en has the same shape. Style: docs/FINNISH-STYLE.md (sinä-muoto, no jargon).
import { defineArea } from '../area';

const n = (k: number, one: string, many: string) => `${k} ${k === 1 ? one : many}`;

export const listenCardsFi = {
  prompt: 'Mitä sana tarkoittaa?',
  play: 'Kuuntele',
  slow: 'Hitaasti',
  failed: 'Äänitettä ei voitu toistaa. Yritä uudelleen.',
  /** After the answer: the written word and its reference. */
  showText: 'Näytä teksti',
  /** Whose voice the card plays. */
  voice: {
    peterson: 'Peterson',
    cut: 'Peterson · leikattu lauseesta',
    ours: (who: string) => `meidän ääntämys · ${who}`,
  },
  voiceLabel: (v: string) => `Ääni: ${v}`,
  /** The word page: may this take voice a listening card? */
  approval: {
    head: 'Kuuntelukortin äänenä',
    mine: 'Sinun äänitteesi',
    usable: 'käytössä',
    notYet: 'ei vielä käytössä',
    stressOk: 'paino osui kohdalleen',
    approvedBy: (names: string[]) => `${names.length === 1 ? 'hyväksynyt' : 'hyväksyneet'}: ${names.join(', ')}`,
    approve: 'Kelpaa',
    approveName: (who: string) => `Kelpaa kuuntelukorttiin: ${who}`,
  },
  /** The week's Kuuntele step. */
  week: {
    head: 'Kuuntelukortit',
    cards: (k: number) => n(k, 'kortti', 'korttia'),
    waiting: (k: number) => `${n(k, 'sana', 'sanaa')} saa kuuntelukortin, kun olet tunnistanut ${k === 1 ? 'sen' : 'ne'} kolmena eri päivänä.`,
    locked: (lesson: number) => `Kuuntelukortit avautuvat, kun olet läpäissyt oppitunnin ${lesson}.`,
    start: 'Kuuntele viikon sanat',
    run: (week: number) => `Viikon ${week} kuuntelukortit`,
    empty: 'Viikon sanoilla ei ole vielä kuuntelukortteja.',
  },
};

export const listenCardsEn: typeof listenCardsFi = {
  prompt: 'What does the word mean?',
  play: 'Listen',
  slow: 'Slowly',
  failed: 'The recording could not be played. Try again.',
  showText: 'Show the text',
  voice: {
    peterson: 'Peterson',
    cut: 'Peterson · cut from a sentence',
    ours: (who) => `our pronunciation · ${who}`,
  },
  voiceLabel: (v) => `Voice: ${v}`,
  approval: {
    head: 'As a listening card’s voice',
    mine: 'Your take',
    usable: 'in use',
    notYet: 'not in use yet',
    stressOk: 'the stress was on target',
    approvedBy: (names) => `approved by: ${names.join(', ')}`,
    approve: 'Good enough',
    approveName: (who) => `Good enough for a listening card: ${who}`,
  },
  week: {
    head: 'Listening cards',
    cards: (k) => `${k} ${k === 1 ? 'card' : 'cards'}`,
    waiting: (k) =>
      `${k} ${k === 1 ? 'word becomes a listening card once you have recognised it' : 'words become listening cards once you have recognised them'} on three days.`,
    locked: (lesson) => `Listening cards open once you have passed lesson ${lesson}.`,
    start: 'Listen to the week’s words',
    run: (week) => `Week ${week}’s listening cards`,
    empty: 'The week’s words have no listening cards yet.',
  },
};

// Messages.listenCards (i18n/area.ts: collected by area-registry.ts)
export const area = defineArea('listenCards', listenCardsFi, listenCardsEn);
declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof listenCardsFi> {}
}
